import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
  type AuthState,
  createAuthSlice,
} from './use-auth-store/use-auth-store';
import { createMetaSlice, MetaState } from './use-meta-store/use-meta-store';

export { type AuthState, type MetaState };

export type SharedStoreState = AuthState & MetaState;

//docs: https://github.com/pmndrs/zustand/blob/main/docs/guides/slices-pattern.md
export const useBoundStore = create<SharedStoreState>()(
  devtools(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createMetaSlice(...a),
    }),
    { enabled: process.env.NODE_ENV === 'development' },
  ),
);
